/** e.g. "Friday, 5/29/2026 at 11:00 AM" */
export function formatMeetingDisplayTime(
  startTime?: string,
  fallback?: string
): string {
  if (!startTime) {
    return fallback ?? "";
  }

  const date = new Date(startTime);
  if (Number.isNaN(date.getTime())) {
    return fallback ?? "";
  }

  const weekday = new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(date);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  const time = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(date);

  return `${weekday}, ${month}/${day}/${year} at ${time}`;
}

/** e.g. "31 July 26, 4:00 AM" for admin tables */
export function formatModerationDateTime(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  const day = date.getDate();
  const month = new Intl.DateTimeFormat("en-US", { month: "long" }).format(date);
  const year = String(date.getFullYear()).slice(-2);
  const time = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(date);

  return `${day} ${month} ${year}, ${time}`;
}

export function formatScheduledDateTime(value: string): string {
  return formatModerationDateTime(value);
}
